module.exports = __webpack_public_path__ + "static/img/check2.574e5b9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/check2.gif
// module id = XkMq
// module chunks = 1